import React, { useState } from "react";
import { Y, T } from "../theme";
import { Logo, LeopardBg } from "./shared";
import { IcoGenerate } from "../icons";
import { signInWithDiscord } from "../firebase";

const DISCORD_BLURPLE = "#5865F2";

export default function LoginScreen({ onLogin, signingIn }) {
  const [discordBusy, setDiscordBusy] = useState(false);
  const [discordError, setDiscordError] = useState(null);

  const onDiscord = async () => {
    setDiscordError(null);
    setDiscordBusy(true);
    try {
      await signInWithDiscord();
      // onAuthStateChanged in App.js takes over from here.
    } catch (e) {
      setDiscordError(e.message || "Discord sign-in failed");
      setDiscordBusy(false);
    }
  };

  const busy = signingIn || discordBusy;

  return (
    <div style={{minHeight:"100vh",background:T.bg,display:"flex",alignItems:"flex-start",justifyContent:"center",paddingTop:"12vh",padding:"12vh 24px 24px",position:"relative",overflow:"hidden",fontFamily:"Mulish,sans-serif"}}>
      <LeopardBg/>
      <div style={{position:"fixed",top:-300,left:"50%",transform:"translateX(-50%)",width:700,height:500,background:`radial-gradient(ellipse,${Y}07 0%,transparent 70%)`,pointerEvents:"none",zIndex:0}}/>
      <div style={{background:"transparent",maxWidth:360,width:"100%",textAlign:"center",position:"relative",zIndex:1}}>

        <div style={{display:"flex",justifyContent:"center",marginBottom:10}}><Logo size={72}/></div>
        <div style={{fontSize:22,fontWeight:200,letterSpacing:2,color:T.title,marginBottom:28,textTransform:"uppercase"}}>Studio</div>

        {/* Generate icon */}
        <div style={{marginBottom:32,color:T.text3,display:"flex",justifyContent:"center"}}>
          <IcoGenerate s={22} c={T.text3}/>
        </div>

        {busy ? (
          /* Signing in indicator */
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:16}}>
            <style>{`
              @keyframes login-spin { to { transform: rotate(360deg); } }
            `}</style>
            <div style={{width:32,height:32,border:`3px solid ${Y}22`,borderTop:`3px solid ${Y}`,borderRadius:"50%",animation:"login-spin 0.8s linear infinite"}}/>
            <span style={{color:T.text3,fontSize:12,fontWeight:500,letterSpacing:"0.04em"}}>Signing in…</span>
          </div>
        ) : (
          /* Sign in buttons */
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:12,marginBottom:20}}>
            <button onClick={onLogin} title="Sign in with Google"
              style={{padding:"12px 24px",borderRadius:30,background:Y,border:"none",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:12}}>
              <svg width="22" height="22" viewBox="0 0 24 24" aria-label="Google" fill="#0C0E0F">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-label="Sign in">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" stroke="#0C0E0F" strokeWidth="2.5" strokeLinecap="round"/>
                <polyline points="10 17 15 12 10 7" stroke="#0C0E0F" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="15" y1="12" x2="3" y2="12" stroke="#0C0E0F" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
            </button>
            <button onClick={onDiscord} title="Sign in with Discord"
              style={{padding:"12px 24px",borderRadius:30,background:DISCORD_BLURPLE,border:"none",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:12}}>
              <svg width="22" height="22" viewBox="0 0 24 24" aria-label="Discord" fill="#FFFFFF">
                <path d="M20.317 4.37a19.79 19.79 0 0 0-4.885-1.515.07.07 0 0 0-.074.035c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.074-.035 19.74 19.74 0 0 0-4.885 1.515.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.873-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.1 13.1 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.3 12.3 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.84 19.84 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.331c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
              </svg>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-label="Sign in">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round"/>
                <polyline points="10 17 15 12 10 7" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="15" y1="12" x2="3" y2="12" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
            </button>
            {discordError && (
              <div style={{color:T.danger,fontSize:11,marginTop:4,maxWidth:300}}>{discordError}</div>
            )}
          </div>
        )}

      </div>
    </div>
  );
}
